/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import {Tooltip} from '@mui/material';
import Avatar from '@mui/material/Avatar';
import {deepOrange} from '@mui/material/colors';
import React from 'react';
import { withUser } from '../../UserProvider';

export default withUser(({ user }) => ({
	user
}))(function UserAvatar(props) {

	return (
		<div
			style={{
				marginRight: '20px',
				display: 'flex',
			}}
		>
			{props.users ?
				props.users.map((selection) =>
					selection === props.user.displayName ? null:
						<Tooltip
							placement="bottom"
							enterDelay={500}
							title={selection}
						>
						<Avatar
							sx={{
								bgcolor: deepOrange[500],
								border: '1px solid white',
								width: 32,
								height: 32,
								marginLeft: '-6px',
							}}
						>
							{selection[0].toUpperCase()}
					</Avatar>
						</Tooltip>
				)
				: null}
		</div>
	);
});
